import PlanCard from "./PlanCard";

interface PricingPlansProps {
  isPlayBillingAvailable: boolean;
  user?: any;
}

export default function PricingPlans({
  isPlayBillingAvailable,
  user
}: PricingPlansProps): JSX.Element {
  return (
    <div className="flex flex-col gap-8 mt-10 md:flex-row md:gap-8 md:items-center md:justify-center">
      <PlanCard
        type="free"
        title="Gratuito"
        price="R$ 0"
        description="Ideal para começar seus estudos com as funcionalidades básicas do Vstiba."
        features={[
          "5 mensagens por dia no Chat de Questões",
          "10 questões respondidas por dia",
          "Plano de estudos",
          "Curadoria de aulas",
          "Gráficos básicos de desempenho"
        ]}
        isPlayBillingAvailable={isPlayBillingAvailable}
        user={user}
      />

      <PlanCard
        type="premium"
        title="Vstiba Total"
        price="R$ 19,90"
        description="Para quem quer se preparar com todas as ferramentas disponíveis para o ENEM e vestibulares."
        features={[
          "Tudo do plano gratuito",
          "Sem limite de questões por dia",
          "100 mensagens por dia no Chat de Questões",
          "Modo Prova",
          "Gráficos de desempenho avançados"
        ]}
        isHighlighted={true}
        isPlayBillingAvailable={isPlayBillingAvailable}
        user={user}
      />
    </div>
  );
}
